import { singleton, inject } from "tsyringe";

// shared
import type { HttpAdapter } from "@/shared/libs/http/interface";

// domain
import {
    AcademyRegistrationRequestRepository,
    RequestGetAcademyRegistrationRequestPayload,
    RequestPatchAcademyRegistrationRequestPayload,
} from "@/entities/academy-registration-request/domain/repository";
import type {
    GetAcademyRegistrationListResponseDto,
    AcademyRegistrationResponseDto,
} from "@/entities/academy-registration-request/domain/dtos";

@singleton()
export default class AcademyRegistrationRequestRepositoryImpl
    implements AcademyRegistrationRequestRepository
{
    constructor(@inject("HttpAdapter") private readonly httpAdaptor: HttpAdapter) {}

    /** @description 승인대기자를 호출합니다. */
    public getAcademyRegistrationRequests = async (
        payload: RequestGetAcademyRegistrationRequestPayload,
    ) => {
        let url = `/v1/academy-registration-requests?academyId=${payload.academyId}&status=0&`;

        if (payload.size) {
            url += `size=${payload.size}`;
        } else {
            url += `size=8`;
        }

        if (payload.nextToken) {
            url += `&nextToken=${payload.nextToken}`;
        }

        const response = await this.httpAdaptor.get<GetAcademyRegistrationListResponseDto>(url);

        return response;
    };

    /** @description 학생 승인요청에 대한 승인, 취소(거절) */
    public patchAcademyRegistrationRequest = async (
        payload: RequestPatchAcademyRegistrationRequestPayload,
    ) => {
        const response = await this.httpAdaptor.patch<AcademyRegistrationResponseDto>(
            `/v1/academy-registration-requests/${payload.academyRegistrationRequestId}`,
            payload.requestDto,
        );

        return response;
    };
}
